import TagManager from 'react-gtm-module';

const history: string[] = [];

export const trackPageView = (page: string, data?: {}) => {
  if (history[history.length - 1] !== page) {
    history.push(page);

    // console.log('trackPageView', page, data);
    if (process.env.REACT_APP_ENV !== 'dev') {
      TagManager.dataLayer({
        dataLayer: {
          event: 'page_view',
          page,
          ...data,
        },
      });
    }
  }
};

export const trackEvent = (event: string, data?: {}) => {
  // console.log('trackEvent', event, data);
  if (process.env.REACT_APP_ENV !== 'dev') {
    TagManager.dataLayer({
      dataLayer: {
        event,
        ...data,
      },
    });
  }
};

export const getCurrentPage = () => {
  return history[history.length - 1] || '/';
};
